/* eslint-disable eqeqeq */
import { useState } from "react";
import { HiArrowLeft } from "react-icons/hi";
import { key } from "./forgotpassword";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { setPassword, verifyOTP } from "../../../../api/user";
import { showErrorToast } from "../../../../utils/toast";

const checkMark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
  >
    <rect x="5" y="5" width="56" height="56" rx="28" fill="#D1FADF" />
    <path
      d="M44.6668 31.9267V33C44.6654 35.5158 43.8507 37.9638 42.3444 39.9788C40.838 41.9938 38.7207 43.4679 36.3081 44.1812C33.8955 44.8945 31.317 44.8089 28.957 43.937C26.5971 43.0652 24.5823 41.4538 23.2129 39.3433C21.8436 37.2327 21.1933 34.7361 21.3588 32.2257C21.5243 29.7153 22.4969 27.3257 24.1315 25.4133C25.7661 23.5008 27.9751 22.168 30.429 21.6135C32.883 21.0591 35.4505 21.3127 37.7485 22.3367M44.6668 23.6667L33.0002 35.345L29.5002 31.845"
      stroke="#039855"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="5"
      y="5"
      width="56"
      height="56"
      rx="28"
      stroke="#ECFDF3"
      stroke-width="10"
    />
  </svg>
);

export default function ResetPassword() {
  const [page, setPage] = useState(1);
  const navigate = useNavigate()

  const verifyMutation = useMutation(verifyOTP, {
    onSuccess: () => {
      setPage(2);
    },
    onError: (e) => {
      showErrorToast(e.message);
    },
  });

  const resetMutation = useMutation(setPassword, {
    onSuccess: () => setPage(3),
    onError: (e) => showErrorToast(e.message),
  });

  const onVerifyOTP = (e) => {
    e.preventDefault();
    let formData = new FormData(e.target);

    const email = localStorage.getItem("ur-sc");
    const otp = formData.get("otp");
    verifyMutation.mutate({ email, otp });
  };

  const onResetPassword = (e) => {
    e.preventDefault();
    let formData = new FormData(e.target);

    const email = localStorage.getItem("ur-sc");
    const password = formData.get("password");
    const confirmPassword = formData.get("confirmPassword");

    if (password !== confirmPassword) {
      showErrorToast("Password and Confirm Password must be the same");
      return;
    }
    const data = {
      newPassword: password,
      email,
    };

    resetMutation.mutate(data);
  };
  return (
    <div className="font-inter h-screen w-full flex flex-col text-center align-middle items-center bg-white">
      <div className="pt-24 flex flex-col gap-6 items-center max-w-[320px]">
        <div className="flex justify-center">{page == 1 ? key : checkMark}</div>
        <div className="">
          <div className="font-bold text-[#101828] text-[30px]">
            {page == 1 ? "Verify OTP" : "Set new password"}
          </div>
          <div className="text-[#667085] text-[15px]">
            {page == 1
              ? "Enter the OTP sent to your email and confirm it's your account"
              : page ==2 ? "Your new password must be different to previously used passwords" : "You've successfully reset your password. Proceed to login back to your account"}
          </div>
        </div>
        <div className="font-inter w-full flex flex-col gap-10 items-center">
          {page == 1 ? (
            <>
              <form onSubmit={onVerifyOTP} className="flex flex-col gap-4">
                <div className="flex flex-col gap-1 items-start">
                  <div className="text-[#344054] text-[14px] font-medium">
                    OTP
                  </div>
                  <div className="w-fit">
                    <input
                      name="otp"
                      type="text"
                      className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                      placeholder="OTP"
                    />
                  </div>
                </div>
                <div className="pt-2 w-full flex">
                  <button
                    type="submit"
                    className="w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3"
                  >
                    Verify OTP
                  </button>
                </div>
              </form>
            </>
          ) : page == 2 ? (
            <form onSubmit={onResetPassword} className="flex flex-col gap-4">
              <div className="flex flex-col gap-1 items-start">
                <div className="text-[#344054] text-[14px] font-medium">
                  Password
                </div>
                <div className="w-fit">
                  <input
                    name="password"
                    type="password"
                    className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                    placeholder="Password"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-1 items-start">
                <div className="text-[#344054] text-[14px] font-medium">
                  Confirm password
                </div>
                <div className="w-fit">
                  <input
                    name="confirmPassword"
                    type="password"
                    className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                    placeholder="Confirm Password"
                  />
                </div>
              </div>
              <div className="pt-2 w-full flex">
                <button
                  type="submit"
                  className="w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3"
                >
                  Reset password
                </button>
              </div>
            </form>
          ) : (
            <div className="pt-2 w-full flex">
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3"
              >
                Continue
              </button>
            </div>
          )}
          <div className="">
            <Link
              to="/login"
              className="text-[14px] font-medium text-[#667085] flex items-center gap-2"
            >
              <HiArrowLeft />
              <span>Back to log in</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
